import { ReactNode } from 'react';

import { SectionHeading, SectionDescription } from '@pangea-lis-apps/ui';
export interface ContentSectionProps {
	id?: string;
	heading?: string;
	className?: string;
	children: ReactNode;
	customWidth?: string;
	paddingClassName?: string;
	description?: ReactNode;
	headingAction?: ReactNode;
}

export function ContentSection(props: ContentSectionProps) {
	const paddingClassName = props.paddingClassName ?? 'px-4 sm:px-6 lg:px-8';

	return (
		<section
			id={props.id}
			className={`${paddingClassName} ${props.customWidth ?? ''} ${props.className ?? ''}`}
		>
			{(props.heading || props.description || props.headingAction) && (
				<div className="flex items-center justify-between mb-4">
					<div>
						{props.heading && (
							<SectionHeading
								text={props.heading}
								className={props.description ? 'mb-2' : ''}
							/>
						)}
						{props.description && (
							<SectionDescription content={props.description} />
						)}
					</div>

					{props.headingAction}
				</div>
			)}

			{props.children}
		</section>
	);
}

export default ContentSection;
